import { registerWidget, DME } from "dmeditor";
import { Search, SearchDefinition } from "./search";

export default () => {
  registerWidget(SearchDefinition, {
    render: Search,
  });
};
